import uiI18n from "../i18n";
import React from "react";
import {
  FaShoppingCart,
  FaKey,
  FaUmbrellaBeach,
  FaSearchLocation,
} from "react-icons/fa";
import { BiSolidOffer } from "react-icons/bi";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function HeaderMenu({
  handleMenuItemClick,
}) {
  const { t } = useTranslation();
  const location = useLocation();

  // Desktop navigation: no "Accueil" entry, the logo leads home (the mobile menu keeps it).
  const menuItems = [
    {
      name: t("buy"),
      icon: FaShoppingCart,
      path: "/Category/sale",
    },
    {
      name: t("rent"),
      icon: FaKey,
      path: "/Category/rent",
    },
    {
      name: t("offers"),
      icon: BiSolidOffer,
      path: "/offers",
    },
    {
      name: t("vacances"),
      icon: FaUmbrellaBeach,
      path: "/Vacation",
    },
    {
      name: t("propertyRequest.nav.public"),
      icon: FaSearchLocation,
      path: "/property-requests",
      badge: t("propertyRequest.nav.new"),
    },
  ];

  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }

    return location.pathname
      .toLowerCase()
      .startsWith(path.toLowerCase());
  };

  return (
    <nav className="lina-desktop-nav" aria-label={uiI18n.t("ui.main_navigation")}>
      <ul className="flex items-center gap-1">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);

          return (
            <li key={item.path}>
              <button
                type="button"
                aria-current={active ? "page" : undefined}
                onClick={() =>
                  handleMenuItemClick(item.path)
                }
                className={`
                  relative
                  flex
                  items-center
                  gap-2
                  rounded-xl
                  px-3
                  py-2.5
                  text-sm
                  font-semibold
                  transition
                  duration-200
                  ${
                    active
                      ? "bg-green-50 text-green-700"
                      : "text-slate-600 hover:bg-slate-100 hover:text-slate-950"
                  }
                `}
              >
                <Icon
                  size={13}
                  className={
                    active
                      ? "text-green-600"
                      : "text-slate-400"
                  }
                />

                <span className="whitespace-nowrap">{item.name}</span>{" "}
                {item.badge && (
                  <span className="rounded-full bg-green-700 px-2 py-0.5 text-xs font-bold text-white">
                    {item.badge}
                  </span>
                )}

              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}